module.exports = __webpack_public_path__ + "static/img/piece_2001.7c3bf39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/piece_2001.png
// module id = P0Rg
// module chunks = 0